import { render, staticRenderFns } from "./CompanySector.vue?vue&type=template&id=55b4fb14&scoped=true&"
import script from "./CompanySector.vue?vue&type=script&lang=js&"
export * from "./CompanySector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4fb14",
  null
  
)

export default component.exports